import { render, staticRenderFns } from "./TableMusicRs.vue?vue&type=template&id=08324a6b&scoped=true&"
import script from "./TableMusicRs.vue?vue&type=script&lang=js&"
export * from "./TableMusicRs.vue?vue&type=script&lang=js&"
import style0 from "./TableMusicRs.vue?vue&type=style&index=0&id=08324a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08324a6b",
  null
  
)

export default component.exports